import api from './api';

export default {
  getOrdersForKitchen() {
    return api.get('/permissions/orders/cafe');
  }
};
